const getTextVisibleLength = (text: string) => {
  let count = 0
  const arr = [...text]

  for (let c = 0; c < arr.length; c++) {
    if (
      arr[c] != '\u{200D}' &&
      arr[c + 1] != '\u{200D}' &&
      arr[c + 1] != '\u{fe0f}' &&
      arr[c + 1] != '\u{20e3}'
    ) {
      count++
    }
  }
  return count
}

export default getTextVisibleLength
